$(document).ready(function() {

	//	Start Show scroll to top button
	var progressPath = document.querySelector('.scroll-to-top-button .progress-circle path');
	var pathLength = progressPath.getTotalLength();
	progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
	progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
	progressPath.style.strokeDashoffset = pathLength;
	progressPath.getBoundingClientRect();
	progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';
	var updateProgress = function() {
		var scroll = $(window).scrollTop();
		var height = $(document).height() - $(window).height();
		var progress = pathLength - (scroll * pathLength / height);
		progressPath.style.strokeDashoffset = progress;
	}
	updateProgress();
	$(window).scroll(updateProgress);
	var offset = 150;
	var duration = 550;
	jQuery(window).on('scroll', function() {
		if (jQuery(this).scrollTop() > offset) {
			jQuery('.scroll-to-top-button').addClass('active-progress');
		} else {
			jQuery('.scroll-to-top-button').removeClass('active-progress');
		}
	});
	jQuery('.scroll-to-top-button').on('click', function(event) {
		event.preventDefault();
		jQuery('html, body').animate({
			scrollTop: 0
		}, duration);
		return false;
	})
	//	End Show scroll to top button

	// Start Product Page Lightbox
	var lightbox = GLightbox({
		autoplayVideos: true,
		selector: ".enable-zoom .image-popup",
		title: false,
		openEffect: "zoom",
		closeEffect: "fade",
		fade: {
			in: "fadeIn",
			out: "fadeOut",
		},
		zoom: {
			in: "zoomIn",
			out: "zoomOut",
		},
	});
	var lightboxVideo = GLightbox({
		selector: '.video-popup'
	});

	lightboxVideo.on('slide_changed', ({
		prev,
		current
	}) => {
		console.log('Prev slide', prev);
		console.log('Current slide', current);

		const {
			slideIndex,
			slideNode,
			slideConfig,
			player
		} = current;

		if (player) {
			if (!player.ready) {
				// If player is not ready
				player.on('ready', (event) => {
					// Do something when video is ready
				});
			}

			player.on('play', (event) => {
				console.log('Started play');
			});

			player.on('volumechange', (event) => {
				console.log('Volume change');
			});

			player.on('ended', (event) => {
				console.log('Video ended');
			});
		}
	});
	// End Product Page Lightbox

	// Start Fake Sales Notifications
	document.querySelectorAll(".toast").forEach(function(t) {
		new bootstrap.Toast(t, {
			autohide: false,
		}).show();
	});
	// End Fake Sales Notifications

	// Start Product Page Slider
	function alllySwiper() {
		var swiper = new Swiper(".layout-thumb", {
			loop: false,
			spaceBetween: 10,
			slidesPerView: 4,
			freeMode: true,
			watchSlidesProgress: true,
		});
		var swiper2 = new Swiper(".layout-2, .layout-3, .layout-4", {
			loop: true,
			spaceBetween: 10,
			navigation: {
				nextEl: ".product-swiper-button-next",
				prevEl: ".product-swiper-button-prev",
			},
			thumbs: {
				swiper: swiper,
			},
		});
	}
	document.addEventListener("shopify:section:load", () => {
		alllySwiper()
	});
	$(() => {
		alllySwiper()
	});

	function standardSwiper() {
		var swiper = new Swiper(".prod-layout-standard, .layout-standard", {
			loop: false,
			spaceBetween: 10,
			slidesPerView: 5,
			watchSlidesProgress: true,
		});

		var swiper2 = new Swiper(".featured-product", {
			loop: false,
			// spaceBetween: 10,
			navigation: {
				nextEl: ".product-swiper-button-next",
				prevEl: ".product-swiper-button-prev",
			},
			thumbs: {
				swiper: swiper,
			},
		});
		var dataSwiper = document.querySelector('.layout-1');
		if(dataSwiper != null){
			dataSwiper = document.querySelector('.layout-1').getAttribute("data-swiper");
			var swiper2 = new Swiper(".layout-1",JSON.parse(dataSwiper));
			swiper2.thumbs.swiper = swiper;
		}
	}
	document.addEventListener("shopify:section:load", () => {
		standardSwiper()
	});
	document.addEventListener("shopify:quickview",(event) =>{
		var swiperContainer = event.detail.swiper;
		var thumbnailSwiper = event.detail.thumbnailSwiper;
		if(swiperContainer.classList.contains("layout-1")){
			swiperContainer.classList.add("quick-product");
			thumbnailSwiper.classList.add("thumbnailSwiper-quickProduct");
			setTimeout(function(){
				standardSwiper
				var swiperquick = new Swiper(".thumbnailSwiper-quickProduct", {
					loop: false,
					spaceBetween: 10,
					slidesPerView: 5,
					watchSlidesProgress: true,
				});
				const swiperquick3 = new Swiper('.quick-product', {
					loop: false,
					navigation: {
						nextEl: ".product-swiper-button-next",
						prevEl: ".product-swiper-button-prev",
					},
					thumbs: {
						swiper: swiperquick,
					},
				});
			},1000)
		}
		if(swiperContainer.classList.contains("layout-5")){
			swiperContainer.classList.add("quick-product");
			thumbnailSwiper.classList.add("thumbnailSwiper-quickProduct");
			var swiperthumbnail = new Swiper(".thumbnailSwiper-quickProduct", {
				loop: false,
				spaceBetween: 10,
				slidesPerView: 6,
				freeMode: true,
				watchSlidesProgress: true,
				slideToClickedSlide: true,
				breakpoints: {
					768: {
						direction: "vertical"
					},
				},
			});
			var swiper2 = new Swiper(".quick-product", {
				loop: false,
				rewind: true,
				navigation: {
					nextEl: ".product-swiper-button-next",
					prevEl: ".product-swiper-button-prev",
				},
				thumbs: {
					swiper: swiperthumbnail,
				},
			});
		}
	});
	$(() => {
		standardSwiper()
	});

	function prodSwiper() {
		var swiperthumbnail = new Swiper(".thumbnail-list", {
			loop: false,
			spaceBetween: 10,
			slidesPerView: 6,
			freeMode: true,
			watchSlidesProgress: true,
			slideToClickedSlide: true,
			breakpoints: {
				768: {
					direction: "vertical"
				},
			},
		});
		var swiper2 = new Swiper(".prod-slider", {
			loop: false,
			rewind: true,
			navigation: {
				nextEl: ".product-swiper-button-next",
				prevEl: ".product-swiper-button-prev",
			},
			thumbs: {
				swiper: swiperthumbnail,
			},
		});

	}
	document.addEventListener("shopify:section:load", () => {
		prodSwiper()
	});
	$(() => {
		prodSwiper()
	});

	function lysixSwiper() {
		var swiper = new Swiper(".ly6", {
			loop: false,
			spaceBetween: 10,
			slidesPerView: 4,
			freeMode: true,
			watchSlidesProgress: true,
			breakpoints: {
				1200: {
					direction: "vertical"
				},
			},
		});
		var swiper2 = new Swiper(".layout-6", {
			direction: "vertical",
			loop: false,
			autoHeight: true,
			slidesPerView: 1,
			spaceBetween: 10,
			navigation: {
				nextEl: ".product-swiper-button-next",
				prevEl: ".product-swiper-button-prev",
			},
			thumbs: {
				swiper: swiper,
			},
		});
	}
	document.addEventListener("shopify:section:load", () => {
		lysixSwiper()
	});
	$(() => {
		lysixSwiper()
	});

	// End Product Page Slider

});

// Start BootStarp Form Validator
//PROGRESS ICON
// Example starter JavaScript for disabling form submissions if there are invalid fields
(() => {
	"use strict";

	// Fetch all the forms we want to apply custom Bootstrap validation styles to
	const forms = document.querySelectorAll(".needs-validation");

	// Loop over them and prevent submission
	Array.from(forms).forEach((form) => {
		form.addEventListener(
			"submit",
			(event) => {
				if (!form.checkValidity()) {
					event.preventDefault();
					event.stopPropagation();
				}
				form.classList.add("was-validated");
			},
			false
		);
	});
})();
// End BootStarp Form Validator

function currencyFormSubmit(event) {
    event.target.form.submit();
  }

  document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
    element.addEventListener('change', currencyFormSubmit);
  });


$(document).ready(function() {

	// Start Infinite scroll & View More
	function InfiniteScroll() {
		$(".infinite-scroll").infiniteScroll({
			path: ".page-next",
			append: ".infinite-scroll .item",
			status: ".scroller-status",
			history: !1,
		});

		$(".view-more-option").infiniteScroll({
			path: ".page-next",
			append: ".view-more-option .item",
			status: ".page-load-status",
			button: ".view-more-button",
			scrollThreshold: false,
			history: !1
		});

		$('.viw-more-option').on('append.infiniteScroll',function(){
			initButtons();
		});
		$('.infinite-scroll').on('append.infiniteScroll',function(){
			initButtons();
		});

		var maxPage = $('#featured-products-grid').attr('max-page-data');
			let infScroll = $(".infinite-scroll").data('infiniteScroll');
			$(".infinite-scroll").on( 'load.infiniteScroll', function( event, body, path, response ) {
			if(infScroll.pageIndex  == maxPage){
				$(".infinite-scroll").infiniteScroll({
				loadOnScroll: false,
				});
			}
		});
	}
	// End Infinite scroll & View More

	//	CountDown Start
	function CountDown() {
		var time = $(".count-down");
		if (time.length) {
			var endDate = new Date(time.data("end-date"));
			time.countdown({
				date: endDate,
				render: function(data) {
					$(this.el).html(
						'<div class="time-block"><span class="countdown-timer">' +
						this.leadingZeros(data.days, 3) +
						'</span><span class="time-unit">days</span></div><div class="time-block"><span class="countdown-timer">' +
						this.leadingZeros(data.hours, 2) +
						'</span><span class="time-unit">hrs</span></div><div class="time-block"><span class="countdown-timer">' +
						this.leadingZeros(data.min, 2) +
						'</span><span class="time-unit">mins</span></div><div class="time-block"><span class="countdown-timer">' +
						this.leadingZeros(data.sec, 2) +
						'</span><span class="time-unit">secs</span></div>'
					);
				},
			});
		}
	}
	//	CountDown End

	// this code helps to when we add section it will add that section js files to body.
	document.addEventListener('shopify:section:load', async (evt) => {
		// Function to create and load a script dynamically
		function loadScript(src) {
			return new Promise((resolve, reject) => {
				const s = document.createElement('script');
				s.src = src;
				s.defer = true; // Optional: use defer if needed
				s.onload = () => resolve(src);
				s.onerror = () => reject(new Error(`Script load error for ${src}`));
				document.body.appendChild(s);
			});
		}

		// Load and evaluate section-specific scripts immediately
		for (const script of evt.target.querySelectorAll('script[src]')) {
			const src = script.src;

			// Find all existing scripts with the same src
			const existingScripts = Array.from(document.querySelectorAll('script')).filter(
				(s) => s.src === src
			);

			// Add the script if fewer than two scripts with the same src already exist
			if (existingScripts.length < 2) {
				try {
					await loadScript(src);
				} catch (error) {
					console.error(error);
				}
			}
			initializeImageComparison();
		}
	});
	document.addEventListener("shopify:section:load", () => {
		InfiniteScroll();
		CountDown();
		setColumn();
		initializeImageComparison();
	});
	document.addEventListener("shopify:section:unload", () => {
		InfiniteScroll();
		CountDown();
		isImageComparisonInitialized = false;
	});
	document.addEventListener("shopify:section:select", () => {
		InfiniteScroll();
		CountDown();
		initializeImageComparison();
	});
	document.addEventListener("shopify:section:deselect", () => {
		InfiniteScroll();
		CountDown();
		initializeImageComparison();
	});
	document.addEventListener("shopify:section:reorder", () => {
		InfiniteScroll();
		CountDown();
		initializeImageComparison();
	});
	$(() => {
		InfiniteScroll();
		CountDown();
		initializeImageComparison();
	});

});

  $(window).on('load', function () {

	//	Swiper Start
	var sliderSelector = '.swiper-container',
	defaultOptions = {
		breakpointsInverse: true,
		observer: true
	};

	function SwiperContainer() {

		var nSlider = document.querySelectorAll(sliderSelector);

		[].forEach.call(nSlider, function( slider, index, arr )
		{
			var data = slider.getAttribute('data-swiper') || {};

			if (data)
			{
				var dataOptions = JSON.parse(data);
			}

			slider.options = Object.assign({}, defaultOptions, dataOptions);

			var swiper = new Swiper(slider, slider.options);

			/* stop on hover */
			if ( typeof slider.options.autoplay !== 'undefined' && slider.options.autoplay !== false )
			{
				slider.addEventListener('mouseenter', function(e) {
					swiper.autoplay.stop();
				});

				slider.addEventListener('mouseleave', function(e) {
					swiper.autoplay.start();
				});
			}
		});

	}
	//	Swiper End

	// cart drawer countdown start
	function startTimer() {
		var time = $('#CartDrawer').attr('data-timer'); // time to countdown
		time = typeof time != "undefined" ? time : 1 ;
		var countdowntext = $('#CartDrawer').attr('data-text');
		var countDownDate = new Date().getTime() + (time * 60 * 1000); // 5 minutes from now

		// timer
		var timer = setInterval(function() {
			var now = new Date().getTime();
			var distance = countDownDate - now;
			var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
			var seconds = Math.floor((distance % (1000 * 60)) / 1000);
			$('#timer').text(minutes + "m " + seconds + "s ");

			// give expired text by down
			if (distance < 0) {
				clearInterval(timer);
				$('.time-out-content').html(countdowntext);
			}
		  }, 1000);
	}
	// cart drawer countdown end

	/* Press Section JS Start */
	function pressSwiper(){
		var galleryThumbs = document.querySelectorAll(".galleryThumbs");
		galleryThumbs.forEach((galleryThumb)=>{
			var sectionId = galleryThumb.getAttribute("data-sectionId");
			var dataSwiper = galleryThumb.getAttribute("data-swiper");
			var PressInner = new Swiper("#press-inner-"+sectionId,JSON.parse(dataSwiper));
			var galleryTop = document.getElementById("press-content-"+sectionId);
			var galleryTopdataSwiper = galleryTop.getAttribute("data-swiper");
			var pressContent = new Swiper("#press-content-"+sectionId,JSON.parse(galleryTopdataSwiper));
			PressInner.controller.control = pressContent;
		});
	}
	/* Press Section JS End */

	document.addEventListener("shopify:section:load", () => {
		SwiperContainer();
		startTimer();
		/* call press Swiper function */
		pressSwiper();
		initrecentlyViewGrid();
	});
	document.addEventListener("shopify:section:unload", () => {
		SwiperContainer();
		startTimer();
	});
	document.addEventListener("shopify:section:select", () => {
		SwiperContainer();
		startTimer();
	});
	document.addEventListener("shopify:section:deselect", () => {
		SwiperContainer();
		startTimer();
	});
	document.addEventListener("shopify:section:reorder", () => {
		SwiperContainer();
		startTimer();
	});
	$(() => {
		SwiperContainer();
		/* call press Swiper function */
		pressSwiper();
		startTimer();
	});

});